export const LOCAL_STORAGE_FEATURE_NAME = '_cen_feat';
